


import { useEffect } from 'react';
import Parse from '../../parseConfig';
import { isGuestUser, forceLogout } from './authHelpers';


const GUEST_TIMEOUT_HOURS = 1.0; // set to 24 in production


const checkGuestSessionTimeout = async () => {

    const user = Parse.User.current();

    if (!user) {
        //console.log('[GuestSession] No user logged in — skipping timeout check.');
        return;
    }

    console.log('Running guest session timeout check.');

    if (!isGuestUser(user)) {
        //console.log('[GuestSession] Skipping timeout check — not guest user.');
        return;
    }

    const lastActiveStr = localStorage.getItem('guestLastActiveAt');

    if (!lastActiveStr) {
        //console.log('[GuestSession] No lastActiveAt found.');
        return;
    }

    const lastActive = new Date(lastActiveStr);
    const now = new Date();
    const diffHours = (now - lastActive) / (1000 * 60 * 60);

    //console.log(`[GuestSession] Last active ${diffHours.toFixed(2)} hours ago.`);

    if (diffHours > GUEST_TIMEOUT_HOURS) {
        await forceLogout({ redirectToWelcome: true });
    }
    else {
        //console.log('[GuestSession] Session still valid.');
    }
};

const useGuestSessionManager = () => {

    useEffect(() => {
        (async () => {
            await checkGuestSessionTimeout();
        })();

        const activityInterval = setInterval(async () => {
            await checkGuestSessionTimeout();
        }, 4 * 60 * 1000); // Every 4 minutes

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                checkGuestSessionTimeout();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            clearInterval(activityInterval);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
};


export default useGuestSessionManager;


